module.exports = __webpack_public_path__ + "img/人像抠图--支持定制gif.c141d744.gif";